import { useEffect, useMemo, useRef, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetAdByIdData, GetAdByUserIdData, GetAdsData, GetAdsExportData, GetCategoriesData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { adsColumns, typeOfAds, typeOfcurrency, typeOfUsers } from "../../lib/definitions";
import { deleteAdsForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { MdOutlineFileUpload } from "react-icons/md";
import AdsDetailsPop from "../../ui/adsUi/adsDetails";
import AdsFilter from "../../ui/searchFilter/adsFilter";
import NotData from "../../ui/sharedUi/noData";
import i18n from "../../lib/i18n";

export default function Ads() {

    const [searchParams] = useSearchParams();
    const deleteRef = useRef(null);
    const adsRef = useRef(null);
    const [adsData, setAdsData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [adsDetails, setAdsDetails] = useState({});
    const [categoriesParentDataFilter, setCategoriesParentDataFilter] = useState([]);
    const [categoriesChildDataFilter, setCategoriesChildDataFilter] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [openDetails, setOpenDetails] = useState({ isOpen: false, idToOpen: null });
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [showExportDialog, setShowExportDialog] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false); 
    const location = useLocation(); 
    const category_id = searchParams.get('category_id');
    const sub_category_id = searchParams.get('sub_category_id');
    const minPrice = searchParams.get('minPrice');
    const maxPrice = searchParams.get('maxPrice');
    const from_date = searchParams.get('from_date');
    const to_date = searchParams.get('to_date');
    const orderStatus = searchParams.get('orderStatus');
    const typePublisher = searchParams.get('typePublisher');
    const id = searchParams.get('id');
    const currency = searchParams.get('currency');
    const t = i18n.t.bind(i18n); 

    const {userId} = useParams();

    const params = useMemo(() => {
        const tempParams = [];
        if (category_id) tempParams.push({ category_id });
        if (sub_category_id) tempParams.push({ sub_category_id });
        if (minPrice) tempParams.push({ minPrice });
        if (maxPrice) tempParams.push({ maxPrice });
        if (from_date) tempParams.push({ from_date });
        if (to_date) tempParams.push({ to_date });
        if (orderStatus) tempParams.push({ orderStatus });
        if (currency) tempParams.push({ currency });
        if (id) tempParams.push({ id });
        if (typePublisher) tempParams.push({ typePublisher });

        return tempParams;
    }, [ sub_category_id, category_id, minPrice, maxPrice, from_date, to_date, typePublisher, currency, orderStatus, id]);

    useEffect(() => {
        handleApi();
    }, [currentPage, params])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            deleteRef.current && 
            !deleteRef.current.contains(event.target)
            ) {
            closeDeleteConfirmation();
            }
        };

        if (deleteConfirmation.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        };
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [deleteConfirmation.isOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            adsRef.current && 
            !adsRef.current.contains(event.target)
            ) {
                onClose();
            }
        };

        if (openDetails.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        };
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [openDetails.isOpen]);

    useEffect(() => {
        handleFilterCategoryParent();
        handleFilterCategoryChlid();
    }, [])

    const handleApi = async () => {
        setIsLoading(true); 
        let adsData = [];
        if(location.pathname.startsWith("/users/details/")){
            adsData = await GetAdByUserIdData(userId, currentPage, params);
            console.log(adsData)
            setAdsData([]);
            adsData.data.Ads.map((e) => setAdsData((prev) => [...prev, e]));
            setcurrentPage(adsData?.pagination?.current_page);
            setlast_page(adsData?.pagination?.last_page);
        }
        else {
            adsData = await GetAdsData(currentPage, params);
            console.log(adsData)
            setAdsData([]);
            adsData.data.map((e) => setAdsData((prev) => [...prev, e]));
            setcurrentPage(adsData?.pagination?.current_page);
            setlast_page(adsData?.pagination?.last_page);
        };
        setIsLoading(false);  
    };

    const handleFilterCategoryParent = async () => {
        const params = [ {"status" : "main"} ];
        const categoriesDataFilter = await GetCategoriesData(1, params);
        setCategoriesParentDataFilter([]);
        categoriesDataFilter.data.map((e) => setCategoriesParentDataFilter((prev) => [...prev, e]));
    };

    const handleFilterCategoryChlid = async () => {
        const params = [ {"status" : "sub"} ];
        const categoriesDataFilter = await GetCategoriesData(1, params);
        setCategoriesChildDataFilter([]);
        categoriesDataFilter.data.map((e) => setCategoriesChildDataFilter((prev) => [...prev, e]));
    };

    const searchCategoryParent = async (param) => {
        const params = [ {"name": param},{"status" : "main"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesParentDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesParentDataFilter((prev) => [...prev, e]));
        }
    };

    const searchCategoryChild = async (param) => {
        const params = [ {"name": param},{"status" : "sub"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesChildDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesChildDataFilter((prev) => [...prev, e]));
        }
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deleteAdsForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    const openOrderDetails = async (id) => {
        setOpenDetails({ isOpen: true, idToOpen: id });
        const adDetails = await GetAdByIdData(id);
        setAdsDetails({})
        setAdsDetails(adDetails);
    };

    const onClose = () => {
        setOpenDetails({ idToOpen : null, isOpen : false })
        setAdsDetails({});
    };

    const openCloseExportDialog = (e) => {
        setShowExportDialog(e);
    };

    const ExportTableWithPaginiation = async (e) => {
        const exportData = await GetAdsExportData(e, params);
        setExportData([]);
        exportData.data.map((e) => setExportData((prev) => [...prev, e])); 
    };


    return (
        <div className="p-8 sm:p-6 md:p-8">
            {/* {!location.pathname.startsWith("/users/details/") && */}
                {/* (<> */}
                    <div className="">
                        <AdsFilter searchCategoryParent={searchCategoryParent} searchCategoryChild={searchCategoryChild} categoriesChildData={categoriesChildDataFilter} categoriesParentData={categoriesParentDataFilter} typeOfcurrency={typeOfcurrency} typeOfAds={typeOfAds} typeOfUsers={typeOfUsers} values={params}/>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly  justify-between px-5 py-5  gap-4">
                        <h1 className="text-white text-lg ">{t("nav.ads")}</h1>
                        <div onClick={()=>openCloseExportDialog(true)}>
                            <Button background="#232424" borderRadius="8px" border="border border-gray-500/80" color="white" padding="8px 24px" text={t("button.export")} icon={<MdOutlineFileUpload />} />
                        </div>
                    </div>
                {/* </>) */}
             {/* } */}
            { (adsData?.length > 0 || isLoading) &&
                <div>
                    {isLoading ? <TableSkeleton cols={adsColumns}/> : (  
                        <Table name={"Ads"} showExportDialog={showExportDialog} openCloseExportDialog={openCloseExportDialog} ExportTableWithPaginiation={ExportTableWithPaginiation} rowsExportPaginiation={exportData} columns={adsColumns} rows={adsData} action="detailsAds" openDeleteConfirmation={openDeleteConfirmation} openOrderDetails={openOrderDetails} />
                    )}
                </div>
            }
            { (adsData.length < 1 && !isLoading) &&
                <div>
                    <NotData />
                </div>
            }
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>
            {deleteConfirmation.isOpen && <DeleteRecord ref={deleteRef} loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
            {openDetails.isOpen && openDetails.idToOpen && <AdsDetailsPop ref={adsRef} data={adsDetails} onClose={onClose} />}
        </div>
    );
};